"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _size = _interopRequireDefault(require("lodash/size"));

var _beNovativeKit = require("@bit/be-novative.kit.richtext-utils");

var _beNovativeUtils = _interopRequireDefault(require("@bit/be-novative.utils.strip-html"));

var _OverflowCounterModule = _interopRequireDefault(require("./OverflowCounter.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

OverflowCounter.propTypes = {
  inner: _propTypes.default.bool,
  maxLength: _propTypes.default.number,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    getCurrentContent: _propTypes.default.func
  })])
};
OverflowCounter.defaultProps = {
  inner: false,
  maxLength: 200
};

function OverflowCounter(_ref) {
  var inner = _ref.inner,
      maxLength = _ref.maxLength,
      value = _ref.value;
  var remainingChars = maxLength - getLength(value);
  var isOver = remainingChars < 0;
  var classes = (0, _classnames.default)(_OverflowCounterModule.default.OverflowCounter, _defineProperty({}, _OverflowCounterModule.default.float, inner));
  var counterClasses = (0, _classnames.default)(_OverflowCounterModule.default.Counter, _defineProperty({}, _OverflowCounterModule.default.warning, isOver));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: counterClasses
  }, remainingChars));
}

function getLength(value) {
  var textValue = (0, _beNovativeKit.isEditorState)(value) ? (0, _beNovativeKit.rawTextFromState)(value) : value;
  return (0, _size.default)((0, _beNovativeUtils.default)(textValue));
}

var _default = OverflowCounter;
exports.default = _default;

//# sourceMappingURL=OverflowCounter.js.map